import React, { Component } from "react";
import styled from "styled-components";
import { Fonts } from "Themes/Fonts";


const StyledContainer = styled.div`
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  margin: 10px 0px;
  flex: 1;
  width: 100%;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 15px;
  border: 0;
  border: ${props => (props.error ? "solid 2px red" : "solid 2px lightgrey")};
  font-family: $font;
  border-radius: 5px;
`;

class FormInput extends Component {
  state = {
    amount: "0.00"
  };

  handleChange = (event, maskedvalue, floatvalue) => {
    this.setState({ amount: maskedvalue });
  };

  render() {
    const {
      placeholder,
      input: { value, onChange },
      type,
      meta: { touched, error },
      placeholderValue,
      style,
    } = this.props;
    return (
      <StyledContainer>
          <StyledInput
            error={touched && error}
            placeholder={placeholder}
            value={placeholderValue ? placeholderValue : value}
            onChange={onChange}
            type={type}
            style={style}
          />
        {touched && error && <div style={Fonts.errorFont}>{error}</div>}
      </StyledContainer>
    );
  }
}

export default FormInput;
